import { styled, forBrands} from '@core-ui/react-stitch';

const setToggleOffAfterStylesForGap = () => ({
  content: '"off"',
  left: '1.4rem',
  top: '0.3125rem',
});
const setToggleOffAfterStylesForAthleta = () => ({
  content: '"off"',
  left: '1.4rem',
  top: '0.2125rem',
});

const setToggleOffAfterStylesForOldNavy = theme => ({
  content: '"off"',
  left: '1.525rem',
  color: theme.color.gray60,
});

const setToggleOffAfterStylesForBananaRepublic = theme => ({
  content: '""',
  left: '1.15rem',
  top: '0.1250rem',
  color: theme.color.gray80,
});

const toggleOffStyles = theme => ({
  '& .toggle__switch': {
    '&::after': {
      textTransform: 'uppercase',
  ...forBrands(theme, {
      gap: setToggleOffAfterStylesForGap,
      gapfs: setToggleOffAfterStylesForGap,
      on: setToggleOffAfterStylesForOldNavy,
      br: setToggleOffAfterStylesForBananaRepublic,
      brfs: setToggleOffAfterStylesForBananaRepublic,
      at: setToggleOffAfterStylesForAthleta,
  }),
},
},
});

const setToggleStyleForGap = theme => ({
  borderRadius: '1.5rem',
  height: '1.5rem',
  width: '3rem',
  backgroundColor: theme.color.g4,
});

const setToggleStyleForOldNavy = theme => ({
  borderRadius: '1.625rem',
  height: '1.625rem',
  width: '3.5rem',
  backgroundColor: theme.color.g4,
});

const setToggleStyleForBananaRepublic = theme => ({
  borderRadius: '1.25rem',
  height: '1.5rem',
  width: '3rem',
  backgroundColor: theme.color.inverse.b2,
});

const setFontAndColorForGap = theme => ({
  fontWeight: '700',
  fontSize: '10px',
  color: theme.color.g1,
});

const setFontAndColorForBanaRepublic = theme => ({
  fontWeight: '600',
  fontSize: '10px',
  color: theme.color.g1,
});

const setFontAndColorForOldNavy = theme => ({
  fontWeight: '700',
  fontSize: '0.7rem',
  color: theme.color.gray80,
});

const setFontAndColorForAthleta = theme => ({
  fontWeight: '600',
  fontSize: '10px',
  fontVariantLigatures: 'none',
  color: theme.color.g1,
});

const setB2BrandBackgroundColor = theme => ({
  backgroundColor: theme.color.b2,
});

const setToggleSwitchLeftForON = () => ({
  left: '1.975rem',
});

const setToggleSwitchLeftForGap = () => ({
  left: '1.65rem',
});

const setToggleSwitchLeftForBananaRepublic = () => ({
  left: '1.625rem',
});

const setToggleOnBeforeStylesForGap = () => ({
  content: '"on"',
  left: '-1.2rem',
  top: '0.3rem',
});

const setToggleOnBeforeStylesForAthleta = () => ({
  content: '"on"',
  left: '-1.2rem',
  top: '0.2125rem',
});

const setToggleOnBeforeStylesForBR = () => ({
  content: '""',
  left: '-1.2rem',
  top: '0.1250rem',
});

const setToggleOnBeforeStylesForON = () => ({
  content: '"on"',
  left: '-1.375rem',
});

const setSwitchStylesForGap = () => ({
  height: '1.25rem',
  width: '1.25rem',
  left: '0.1860rem',
});

const setSwitchStylesForBR = () => ({
  height: '1.25rem',
  width: '1.25rem',
  left: '0.125rem',
});

const setSwitchStylesForON = () => ({
  height: '1.375rem',
  width: '1.375rem',
  left: '0.1860rem',
});

const ToggleSwitchDivision = styled.button(({theme}) => ({

    background: 'none',
    border: 'none',
    width: 'auto',
    margin: 0,
    padding: 0,
    textAlign: 'inherit',
    font: 'inherit',

    backgroundColor: theme.color.g2,
    ...forBrands(theme, {
      gap: setToggleStyleForGap,
      gapfs: setToggleStyleForGap,
      on: setToggleStyleForOldNavy,
      br: setToggleStyleForBananaRepublic,
      brfs: setToggleStyleForBananaRepublic,
      at: setToggleStyleForGap,
    }),
    margin: 0,
    overflow: 'hidden',
    position: 'relative',
    transition: `${theme.color.g4} 200ms ease-in-out`,

 '& .toggle__switch': {
    backgroundColor: theme.color.wh,
    borderRadius: '50%',
    boxShadow: `0 0.125rem 0.438rem 0 ${theme.color.bkAlpha25}`, //2px 7px
    display: 'block',
    position: 'absolute',
    transition: 'left 200ms linear',
    top: '0.125rem', //2px
    ...forBrands(theme, {
      gap: setSwitchStylesForGap,
      gapfs: setSwitchStylesForGap,
      on: setSwitchStylesForON,
      br: setSwitchStylesForBR,
      brfs: setSwitchStylesForBR,
      at: setSwitchStylesForGap,
    }),
    '&::before , &::after': {
      ...theme.brandFont,
      ...forBrands(theme, {
          gap: setFontAndColorForGap,
          gapfs: setFontAndColorForGap,
          on: setFontAndColorForOldNavy,
          br: setFontAndColorForBanaRepublic,
          brfs: setFontAndColorForBanaRepublic,
          at: setFontAndColorForAthleta,
      }),
      display: 'block',
      position: 'absolute',
      top: '0.25rem',
    },
  },

  '& .toggle__info': {
    position: 'absolute',
    left: '-999em',
    top: '-999em',
  },

  '&.toggle--off': {
    ...toggleOffStyles(theme),
  },

  '&.toggle--on': {
    backgroundColor: theme.color.b1,
    ...forBrands(theme, {
      gap: setB2BrandBackgroundColor,
      gapfs: setB2BrandBackgroundColor,
      br: setB2BrandBackgroundColor,
      brfs: setB2BrandBackgroundColor,
    }),
    '& .toggle__switch': {
      ...forBrands(theme, {
        gap: setToggleSwitchLeftForGap,
        gapfs: setToggleSwitchLeftForGap,
        on: setToggleSwitchLeftForON,
        br: setToggleSwitchLeftForBananaRepublic,
        brfs: setToggleSwitchLeftForBananaRepublic,
        at: setToggleSwitchLeftForGap,
      }),
      '&::before': {
        color: theme.color.wh,
        textTransform: 'uppercase',
        left: '-1.5rem',

        ...forBrands(theme, {
          gap: setToggleOnBeforeStylesForGap,
          gapfs: setToggleOnBeforeStylesForGap,
          on: setToggleOnBeforeStylesForON,
          br: setToggleOnBeforeStylesForBR,
          brfs: setToggleOnBeforeStylesForBR,
          at: setToggleOnBeforeStylesForAthleta,
        }),
      },
    },
  },

  '&.toggle--disabled': {
    ...toggleOffStyles(theme),
    cursor: 'not-allowed',
    '&::after': {
      backgroundColor: theme.color.whAlpha50,
      bottom: 0,
      content: '""',
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },

  }));

  export default ToggleSwitchDivision;